import { EAnalyticsStatus, EMatchingType } from '@enums/campaign-analytics.enum';
import { EPlatformFeature } from '@enums/campaign.enum';
import { IAnalyticsNode, ICampaignAnalytics, TExpectedKpi } from '@interfaces/campaign-analytics.interface';
import { ECampaignDetailsTab } from '../../campaign-details.interface';

export interface ICampaignExportApi {
  id?: string | null;
  campaignId?: string | null;
  name: string;
  detailLevel: EDetailLevel;
  order?: ICampaignExportOrderApi | null;
  // Present on the API response (backend UserAndGroupMixin field) — useful for analytics events
  // fired from no-login contexts, where there's no authenticated user to source it from.
  userGroupId?: string;

  start?: string | null;
  end?: string | null;

  showKpiStatus: boolean;
  showDeliverableStatus: boolean;
  showObservationStatus: boolean;
  showContentStatus: boolean;
  showContentMatchingType: boolean;
  showBudget: boolean;

  allKpisSelected: boolean | null;
  allCreatorsSelected: boolean | null;
  allPlatformFeaturesSelected: boolean | null;
  allTabsSelected: boolean | null;

  isActive: boolean;

  creators: ICampaignExportCreatorApi[] | null;
  platformFeatures: ICampaignExportPlatformFeatureApi[] | null;
  kpis: ICampaignExportKpiApi[] | null;
  tabs: ICampaignExportTabApi[] | null;
  contentMatchingTypes: ICampaignExportContentMatchingTypeApi[] | null;
  contentStatuses: ICampaignExportContentStatusApi[] | null;
  deliverableStatuses: ICampaignExportDeliverableStatusApi[] | null;
  kpiStatuses: ICampaignExportKpiStatusApi[] | null;
  observationStatuses: ICampaignExportObservationStatusApi[] | null;
}

export interface ICampaignExportCreatorApi {
  campaignExportId?: string | null;
  id?: string | null;
  creatorId: string;
}

export interface ICampaignExportPlatformFeatureApi {
  campaignExportId?: string | null;
  id?: string | null;
  platformFeature: EPlatformFeature;
}

export interface ICampaignExportKpiApi {
  campaignExportId?: string | null;
  id?: string | null;
  kpi: TExpectedKpi;
}

export interface ICampaignExportTabApi {
  campaignExportId?: string | null;
  id?: string | null;
  tab: ECampaignDetailsTab;
}

export interface ICampaignExportContentMatchingTypeApi {
  campaignExportId?: string | null;
  id?: string | null;
  matchingType: EMatchingType;
}

export interface ICampaignExportContentStatusApi {
  campaignExportId?: string | null;
  id?: string | null;
  status: EAnalyticsStatus;
}

export interface ICampaignExportDeliverableStatusApi {
  campaignExportId?: string | null;
  id?: string | null;
  status: EAnalyticsStatus;
}

export interface ICampaignExportKpiStatusApi {
  campaignExportId?: string | null;
  id?: string | null;
  status: EAnalyticsStatus;
}

export interface ICampaignExportObservationStatusApi {
  campaignExportId?: string | null;
  id?: string | null;
  status: EAnalyticsStatus;
}

export interface ICampaignExportDialogData {
  campaignAnalytics: ICampaignAnalytics | null;
  analyticsNodes: IAnalyticsNode[] | null;
}

export enum EDetailLevel {
  generalInfo = 'GENERAL_INFO',
  generalAnalytics = 'GENERAL_ANALYTICS',
  detailedAnalytics = 'DETAILED_ANALYTICS',
}

export interface ICampaignExportOrderApi {
  id: string;
  order: number;
}
